// Kullanıcının yazı boyutu tercihi.
//
// Proje Tailwind kullanıyor ve Tailwind'in hem yazı hem boşluk ölçüleri rem
// tabanlı (text-sm = 0.875rem, p-4 = 1rem). Bu yüzden kök (html) font-size'ını
// değiştirmek yazıları da aralıkları da ORANTILI büyütür; düzen bozulmaz.
// Sabit px değerleri (ör. --app-header-h) yerinde kalır, yerleşim kaymaz.
//
// Tercih tarayıcıda saklanır; kullanıcıya özel, sunucuya gitmez.

export const FONT_SCALES = [
  { id: "sm", label: "Küçük", rootPx: 15 },
  { id: "md", label: "Normal", rootPx: 16 },
  { id: "lg", label: "Büyük", rootPx: 18 },
];

export const DEFAULT_FONT_SCALE = "md";

const STORAGE_KEY = "belvizyon-font-scale";

const resolveScale = (id) =>
  FONT_SCALES.find((s) => s.id === id) ||
  FONT_SCALES.find((s) => s.id === DEFAULT_FONT_SCALE);

export const getFontScale = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return FONT_SCALES.some((s) => s.id === stored) ? stored : DEFAULT_FONT_SCALE;
  } catch (err) {
    // Gizli sekme / depolama kapalı: varsayılanla devam et.
    return DEFAULT_FONT_SCALE;
  }
};

export const applyFontScale = (id) => {
  const scale = resolveScale(id);
  if (typeof document !== "undefined" && document.documentElement) {
    document.documentElement.style.fontSize = `${scale.rootPx}px`;
  }
  return scale.id;
};

export const setFontScale = (id) => {
  const applied = applyFontScale(id);
  try {
    window.localStorage.setItem(STORAGE_KEY, applied);
  } catch (err) {
    // Yazılamadıysa tercih yalnız bu oturumda geçerli olur — akış bozulmasın.
    console.debug("Yazı boyutu tercihi kaydedilemedi", err);
  }
  return applied;
};
